import './Hero.css';

const Hero = () => {
  return (
    <div className='contact-hero-container'>
      <div className='contact-hero-top'>
        <div className='contact-hero-mainText'>
          Have some questions? Talk to us
        </div>
        <div className='contact-hero-subText'>
          <p>Your feedback holds value to us. We’re here – ready to help</p>
        </div>
      </div>
      <div className='contact-hero-bottom'>
        <div className='general-container'>
          <div className='contact-box-icon'>
            <img src='/assets/general-icon.svg' alt='' />
          </div>
          <div className='contact-box-mainText'>Phone line</div>
          <div className='contact-box-subText'>
            Need help with onboarding or have a quick questions? Call us on
          </div>
          <a href='tel:+018880277' className='contact-box-link'>
            01-888-0277
          </a>
        </div>
        <div className='general-container email-container'>
          <div className='contact-box-icon'>
            <img src='/assets/email-icon.svg' alt='' />
          </div>
          <div className='contact-box-mainText'>Email</div>
          <div className='contact-box-subText'>
            For general enquiries, feedback, and support. Email us at
          </div>
          <a href="mailto:support@qevolt.com" className='contact-box-link'>
            support@qevolt.com
          </a>
        </div>

        {/* SALES BOX  */}
        <div className='sales-container'>
          <div className='contact-box-icon'>
            <img src='/assets/sales-icon.svg' alt='' />
          </div>
          <div className='contact-box-mainText'>Sales</div>
          <div className='contact-box-subText'>
            Want to discuss pricing and payments? Contact us
          </div>
          <a href='#' className='contact-box-link'>
            Contact Sales
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
